import { GoogleMap } from "@react-google-maps/api";

import React from "react";
const containerStyle = {
  width: "100%",
  height: "300px",
};
let mapOptions = {
  styles: [
    {
      featureType: "administrative",
      stylers: [{ saturation: -35 }, { lightness: 25 }],
    },
    {
      featureType: "landscape",
      stylers: [{ color: "#e3ddda" }, { visibility: "on" }],
    },
    { featureType: "poi", stylers: [{ saturation: -30 }, { lightness: 35 }] },
    {
      featureType: "poi.attraction",
      stylers: [{ saturation: -55 }, { lightness: 5 }],
    },
    { featureType: "poi.business", stylers: [{ saturation: -60 }] },
    {
      featureType: "poi.government",
      stylers: [{ saturation: -55 }, { lightness: 30 }],
    },
    {
      featureType: "poi.medical",
      stylers: [{ saturation: -55 }, { lightness: 30 }],
    },
    {
      featureType: "poi.park",
      elementType: "geometry.fill",
      stylers: [{ color: "#b3dfbe" }],
    },
    { featureType: "road", stylers: [{ saturation: -55 }, { lightness: 40 }] },
    { featureType: "transit", stylers: [{ visibility: "off" }] },
    {
      featureType: "water",
      elementType: "geometry.fill",
      stylers: [{ color: "#bccae1" }],
    },
  ],
  zoomControlOptions: {
    style: "SMALL",
  },
  mapTypeControlOptions: {
    style: "TINY",
  },
  streetViewControl: false,
  disableDoubleClickZoom: true,
  gestureHandling: "greedy",
  fullscreenControl: true,
  zoomControl: true,
  cameraControl: false,
};

export const GoogleMapExample = (props) => {
  return (
    <GoogleMap
      options={mapOptions}
      defaultCenter={props.defaultCenter}
      center={props.defaultCenter}
      zoom={props.zoom}
      onDragEnd={props.onDragEnd}
      onZoomChanged={props.onZoomChanged}
      defaultZoom={12}
      editable={true}
      onPolygonComplete={(polygon) => {
        for (let point of polygon.getPath().getArray()) {
          GeoJSON.geometry.coordinates.push([point.lng(), point.lat()]);
        }
      }}
      mapContainerStyle={containerStyle}
      ref={props.ref}
    ></GoogleMap>
  );
};
